import UserService from "@/services/user/user.service";
import core from "@/core";

export const namespaced = true;

export const state = {
  user: null,
  sessionCheckTime: null,
};

export const actions = {
  async getUser({ commit }, reload) {
    if (reload == null) reload = false;

    const curTime = new Date();
    if (state.sessionCheckTime == null) {
      state.sessionCheckTime = new Date(0);
    }

    if (!reload) {
      //console.log("call getUser");
      const elapsedTimeMillis = curTime.getTime() - state.sessionCheckTime.getTime();
      //console.log(elapsedTimeMillis);
      if (elapsedTimeMillis < 60000) return state.user;
    }

    try {
      state.sessionCheckTime = curTime;
      const user = await UserService.getMyInfo();
      if (user.roles.indexOf("MANAGER") > -1) {
        commit("login", user);
        return user;
      } else {
        console.log("is not support role : ", user.roles);
        actions.logout({ commit: commit });
      }
    } catch (reason) {
      actions.logout({ commit: commit });
    }
    return null;
  },
  async login({ commit }, params) {
    console.log("try login");
    await UserService.login(params);
    state.sessionCheckTime = new Date(0);
    const user = await actions.getUser({ commit: commit }, true);
    //console.log("user : ", user);
    if (user != null) {
      return user;
    }
    core.alert.show({
      title: "알림",
      icon: "error",
      body: "아이디 또는 비밀번호가 올바르지 않습니다",
    });
    throw new Error("로그인 실패");
  },
  async logout({ commit }) {
    try {
      return await UserService.logout();
    } catch (e) {
      console.log(e);
    } finally {
      commit("logout");
    }
  },
};

export const mutations = {
  login(state, user) {
    //console.log('mutations[login]: ', user);
    console.log("update user info");
    state.sessionCheckTime = new Date();
    state.user = user;
  },
  logout(state) {
    //console.log('mutations[logout]: ', state.user);
    if (state.user != null) {
      console.log("logout!");
      state.sessionCheckTime = new Date();
      state.user = null;
    }
  },
};
